<template>
  <div>
    <div class="head-box">
      <h4>{{ typeName }}列表</h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入名称/编号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10" v-if="osg.has(`${fullPath},new`)">
          新增{{ typeName }}
        </el-button>
        <el-button type="primary" @click="copy" class="c-m-l-10" v-if="osg.has(`${fullPath},copy`)">
          复制{{ typeName }}
        </el-button>
        <el-dropdown class="c-m-l-10" @command="audit" v-if="osg.has(`${fullPath},audit`)">
          <el-button type="primary">
            审核
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">提交审核</el-dropdown-item>
            <el-dropdown-item command="2">撤回修改</el-dropdown-item>
            <el-dropdown-item command="3">审核通过</el-dropdown-item>
            <el-dropdown-item command="4">审核不通过</el-dropdown-item>
            <el-dropdown-item command="5">反审</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown class="c-m-l-10" @command="audit" v-if="osg.has(`${fullPath},submitAudit`)">
          <el-button type="primary">
            提交审核
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">提交审核</el-dropdown-item>
            <el-dropdown-item command="2">撤回修改</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          v-if="osg.has(`${fullPath},export`)"
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'fpi-regex:name|string#or': searchValue,
                'fpi-in:state|array-integer#and': '0,1',
                beanName: 'product',
                title: typeName + '列表'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          @selection-change="selectProducts"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column type="selection" width="55" fixed></el-table-column>
          <c-table :fields="extFields">
            <template slot="productState">
              <el-table-column :label="typeName + '状态'" width="150px">
                <template slot-scope="scope">
                  <el-tag effect="plain" v-if="scope.row.productState == '0'">
                    {{ formatProductState(scope.row.productState) }}
                  </el-tag>
                  <el-tag effect="dark" v-else-if="scope.row.productState == '1'">
                    {{ formatProductState(scope.row.productState) }}
                  </el-tag>
                  <el-tag effect="dark" v-else-if="scope.row.productState == '3'" type="success">
                    {{ formatProductState(scope.row.productState) }}
                  </el-tag>
                  <el-tag effect="dark" v-else-if="scope.row.productState == '4'" type="danger">
                    {{ formatProductState(scope.row.productState) }}
                  </el-tag>
                  <el-tag effect="dark" v-else-if="scope.row.productState" type="info">
                    {{ formatProductState(scope.row.productState) }}
                  </el-tag>
                </template>
              </el-table-column>
            </template>
            <template slot="workflowDefId">
              <el-table-column
                prop="workflowDefId"
                label="服务流程"
                :formatter="formatWorkflowDefId"
                width="200px"
                show-overflow-tooltip
              ></el-table-column>
            </template>
            <template slot="depends">
              <el-table-column
                prop="depends"
                label="依赖产品"
                :formatter="formatDepends"
                width="200px"
                show-overflow-tooltip
              ></el-table-column>
            </template>
            <template slot="childs">
              <el-table-column
                prop="childs"
                label="子产品"
                :formatter="formatChildren"
                show-overflow-tooltip
              ></el-table-column>
            </template>
          </c-table>
          <el-table-column
            fixed="right"
            :width="150 + (osg.has(`${fullPath},able`) ? 80 : 0)"
            label="操作"
          >
            <template slot-scope="scope">
              <template v-if="osg.has(`${fullPath},able`)">
                <template v-if="scope.row.state == 0">
                  <el-button
                    @click.native.prevent="doEnable(scope.row._id)"
                    type="danger"
                    size="mini"
                  >
                    已禁用
                  </el-button>
                </template>
                <template v-else>
                  <el-button
                    @click.native.prevent="doDisable(scope.row._id)"
                    type="success"
                    size="mini"
                  >
                    已启用
                  </el-button>
                </template>
              </template>
              <el-button @click.native.prevent="doEdit(scope.row)" size="mini">编辑</el-button>
              <template v-if="loginOrgId == scope.row.orgId || loginOrgId == '0'">
                <el-button @click.native.prevent="doRemove(scope.row._id)" size="mini">
                  删除
                </el-button>
              </template>
            </template>
          </el-table-column>
          <!-- <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has(`${fullPath},able`) && scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    上架
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="osg.has(`${fullPath},able`) && scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    下架
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="loginOrgId == scope.row.orgId || loginOrgId == '0'"
                    @click.native="doRemove(scope.row._id)"
                  >
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog :title="typeName" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        labelWidth="110px"
        @changeForm="osg.changeForm"
      >
        <template slot="workflowDefId">
          <el-select
            v-model="formData.workflowDefId"
            clearable
            @change="$forceUpdate()"
            filterable
            remote
            :remote-method="getWorkflowDef"
            @clear="getWorkflowDef"
            reserve-keyword
            placeholder="可输入服务流程名称搜索查询"
          >
            <el-option
              v-for="item in options.workflowDef"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template slot="depends">
          <el-select
            v-model="formData.depends"
            multiple
            clearable
            @change="$forceUpdate()"
            filterable
            remote
            :remote-method="getProduct"
            @clear="getProduct"
            reserve-keyword
            placeholder="可输入产品名称搜索查询"
          >
            <el-option
              v-for="item in options.product"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item._id == formData._id"
            ></el-option>
          </el-select>
        </template>
        <template slot="childs">
          <el-select
            v-model="formData.childs"
            multiple
            clearable
            @change="$forceUpdate()"
            filterable
            remote
            :remote-method="getProduct"
            @clear="getProduct"
            reserve-keyword
            placeholder="可输入产品名称搜索查询"
          >
            <el-option
              v-for="item in options.product"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item._id == formData._id"
            ></el-option>
          </el-select>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave()">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="审核不通过" :visible.sync="auditObj.show">
      <el-form ref="audit" :model="auditObj" label-width="100px" label-position="left">
        <el-form-item
          label="备注"
          prop="remark"
          placeholder="请输入备注内容"
          :rules="{
            required: true,
            trigger: ['change', 'blur'],
            message: '请输入备注内容'
          }"
        >
          <el-input v-model="auditObj.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="auditConfirm('4', '审核不通过，处理完成。')">
          确 定
        </el-button>
        <el-button
          @click="
            auditObj.show = false;
            auditObj.remark = '';
          "
        >
          取 消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'Products',
  data() {
    window.$this = this;
    return {
      type: '', //3:备件
      typeName: '产品',
      tenantId: '',
      name: 'product',
      refresh: true,
      fpi: {},
      selectedRows: [],
      searchValue: '',
      openDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_productType: { codeId: 'productType' },
        codecfg_productBizType: { codeId: 'productBizType' },
        codecfg_unit: { codeId: 'partUnit' },
        codecfg_productState: { codeId: 'productState' }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 10
      },
      loginOrgId: '',
      auditObj: {
        show: false,
        remark: ''
      },
      fullPath: ''
    };
  },
  mounted() {
    // 当前用户tenantId
    let account = JSON.parse(sessionStorage['loginAccount']);
    this.fullPath = this.$route.fullPath.substring(1);
    this.tenantId = account.tenantId;

    this.doInit();
    this.loginOrgId = JSON.parse(sessionStorage['loginAccount']).orgId;
    this.getProduct();
    this.osg.getFields('product', () => {
      if (this.tenantId != '1340835581184723420') {
        if (this.type == '3') {
          let arr = [];
          for (let obj of this.options.productType) {
            if (obj.value == '3') {
              arr.push(obj);
            }
          }
          this.options.productType = arr;
        } else {
          let arr = [];
          for (let obj of this.options.productType) {
            if (obj.value != '3') {
              arr.push(obj);
            }
          }
          this.options.productType = arr;
        }
        this.$forceUpdate();
      }
      this.osg.getFpi();
      this.getData();
    });
    this.getWorkflowDef();
  },
  methods: {
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    formatCascade(option, arr) {
      let str = '';
      let opts = this.$util.deepCopy(this.options[option]);
      // 单选级联 有几级循环几次
      for (var i = 0; i < arr.length; i++) {
        for (var opt of opts) {
          if (opt.value == arr[i]) {
            str += (opt.label || opt.name) + '、';
            opts = this.$util.deepCopy(opt.children);
            break;
          }
        }
      }
      return str.slice(0, str.length - 1);
    },
    formatUnit(row, column, cellValue) {
      return this.osg.codelabel('unit', cellValue);
    },
    formatProductState(val) {
      return this.osg.codelabel('productState', val);
    },
    formatProductType(row, column, cellValue) {
      return this.osg.codelabel('productType', cellValue);
    },
    formatProductBizType(row, column, cellValue) {
      return this.osg.codelabel('productBizType', cellValue);
    },
    formatWorkflowDefId(row, column, cellValue) {
      return this.osg.codelabel('workflowDef', cellValue);
    },
    formatDepends(row, column, cellValue) {
      return this.osg.codelabelForArray('product', cellValue);
    },
    formatChildren(row, column, cellValue) {
      return this.osg.codelabelForArray('product', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.type = this.osg.param('type');
      if (this.tenantId != '1340835581184723420') {
        if (this.type == '3') {
          this.typeName = '备件';
          this.formData = { productType: '3', exts: {} };
        } else {
          this.typeName = '产品';
          this.formData = { exts: {} };
        }
      } else {
        this.formData = { exts: {} };
      }
      this.openDetail = false;
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      if (this.tenantId != '1340835581184723420') {
        if (this.type == '3') {
          params['is:productType|string#and'] = '3';
        } else if (this.tenantId != '4551453470943235290') {
          params['in:productType|array#and'] = '1,2';
        }
      }
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/product/query.do', params, res => {
        res.data.map(item => {
          if (this.$util.isJson(item.productBizType))
            item.productBizType = JSON.parse(item.productBizType);
        });
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.$util.renderExtField(this.extFields, row);
      if (this.$util.isJson(row.image)) {
        row.image = JSON.parse(row.image);
      }
      this.formData = row;
      this.openDetail = true;
    },
    doSave(copy) {
      let params = this.$util.deepCopy(this.formData);
      // 租户管理员可以修改
      if (
        this.tenantId == '1340835581184723420' &&
        params.orgId &&
        this.loginOrgId != params.orgId &&
        this.loginOrgId != '0'
      ) {
        this.osg.alert('没有权限修改');
        return;
      }

      //新建产品状态默认为'0':待提交
      params.productState = params.productState || '0';
      if (params.productState != '0') {
        this.osg.alert('当前' + this.typeName + '状态不允许修改', () => {
          this.getData();
        });
        return;
      }
      if (!copy) {
        params.image = params.image || [];
        params.image.map(item => {
          if (item.url.indexOf('blob:') != -1) {
            item.url = this.upload.downloadUrl + item.response.key;
          }
        });
        params.image = JSON.stringify(params.image);
      }

      // productBizType转字符串
      if (Array.isArray(params.productBizType)) {
        params.exts.productBizType = params.productBizType;
        params.productBizType = JSON.stringify(params.productBizType);
      }
      this.$util.saveExtField(this.extFields, params);
      if (copy || this.osg.validate()) {
        this.osg.ajax('basic/product/upsert.do', { data: JSON.stringify(params) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax(`basic/product/enable/${id}.do`, null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax(`basic/product/disable/${id}.do`, null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`basic/product/remove/${id}.do`, null, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    getProduct(query) {
      let params = {
        _all: '1',
        'regex:name|string#or': query,
        'in:state|array-integer#and': '0,1',
        'in:productType|array#and': this.tenantId == '4551453470943235290' ? '' : '1,2'
      };
      this.osg.ajax('basic/product/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.product = res.data;
        this.$forceUpdate();
      });
    },
    getWorkflowDef(query) {
      let params = {
        page: 1,
        rows: 20,
        'regex:title|string#or': query,
        'in:state|array-integer#and': '0,1',
        'in:templateType|string#and': 'TT3'
      };
      this.osg.ajax('workflowDef/query.do', params, res => {
        res.data.map(item => {
          item.label = item.title;
          item.value = item._id;
        });
        this.options.workflowDef = res.data;
        this.$forceUpdate();
      });
    },
    // 列表多选
    selectProducts(rows) {
      this.selectedRows = rows;
    },
    // 产品复制
    copy() {
      // 只能选择一个产品
      if (this.selectedRows.length != 1) {
        this.osg.toast(`请选择1个${this.typeName}进行复制`, 'warning');
        return;
      }
      this.formData = this.selectedRows[0];
      delete this.formData._id;
      this.formData.name += ' 副本';
      this.formData.productState = '0';
      this.doSave(true); //copy时不走表单规则校验
    },
    // 审核
    audit(productState) {
      /**
       * productState
       * 0:待提交（服务商新建后是自由态-->状态设为0:待提交）
       * 1:待审核（服务商点提交审核-->状态改为1:待审核）
       * 2:撤回-动作（产品状态为1未审核或4审核未通过时 服务商可以点撤回-->状态改为0:待提交）
       * 3:审核通过（平台点审核通过-->产品状态改为3:审核通过）
       * 4:审核不通过（平台点审核通过-->产品状态改为4:审核不通过）
       * 5:反审-动作（产品状态为3或4已审核时 平台可以点反审-->产品状态改为1:待审核）
       */
      // 至少选择一个产品
      if (this.selectedRows.length == 0) {
        this.osg.toast('请选择要审核的' + this.typeName, 'warning');
        return;
      }
      // 判断选择的产品状态是否符合审核条件
      let msg = '';
      let confirmMsg = '';
      switch (productState) {
        case '1':
          for (let product of this.selectedRows) {
            if (product.productState != '0') {
              this.osg.alert(
                `您选择的${this.typeName}"${product.name}"状态 不符合"提交审核"条件`,
                'warning'
              );
              return;
            }
          }
          confirmMsg = '提交审核';
          msg = '提交成功，待审核。';
          break;
        case '2':
          for (let product of this.selectedRows) {
            if (product.productState != '1' && product.productState != '4') {
              this.osg.alert(`您选择的${this.typeName}"${product.name}"状态 不符合"撤回修改"条件`);
              return;
            }
          }
          confirmMsg = '撤回修改';
          msg = '撤回成功，可修改后重新提交。';
          break;
        case '3':
          for (let product of this.selectedRows) {
            if (product.productState != '1') {
              this.osg.alert(`您选择的${this.typeName}"${product.name}"状态 不符合"审核"条件`);
              return;
            }
          }
          confirmMsg = '审核通过';
          msg = '审核通过，处理完成。';
          break;
        case '4':
          for (let product of this.selectedRows) {
            if (product.productState != '1') {
              this.osg.alert(`您选择的${this.typeName}"${product.name}"状态 不符合"审核"条件`);
              return;
            }
          }
          confirmMsg = '审核不通过';
          msg = '审核不通过，处理完成。';
          break;
        case '5':
          for (let product of this.selectedRows) {
            if (product.productState != '3' && product.productState != '4') {
              this.osg.alert(`您选择的${this.typeName}"${product.name}"还未审核 不符合"反审"条件`);
              return;
            }
          }
          confirmMsg = '反审';
          msg = `反审处理完成，${this.typeName}状态改为待审核。`;
          break;
        default:
      }
      // 确认框
      if (productState != '4') {
        this.osg.confirm(`是否确认${confirmMsg}`, () => {
          this.auditConfirm(productState, msg);
        });
      } else {
        this.auditObj.show = true;
      }
    },
    auditConfirm(productState, msg) {
      if (productState == '4') {
        if (!this.osg.validate('audit')) return;
      }
      let rows = this.$util.deepCopy(this.selectedRows);
      rows.map(row => {
        if (Array.isArray(row.productBizType)) {
          row.productBizType = JSON.stringify(row.productBizType);
        }
      });

      this.osg.ajax(
        'basic/product/change.do',
        {
          data: JSON.stringify({
            products: rows,
            newProductState: productState,
            remark: this.auditObj.remark || null
          })
        },
        () => {
          this.osg.toast(msg);
          this.auditObj.remark = '';
          this.auditObj.show = false;
          this.getData();
        }
      );
    }
  }
  // watch: {
  //   $route() {
  // window.$this = this;
  //  this.doInit();
  // this.loginOrgId = JSON.parse(sessionStorage['loginAccount']).orgId;
  // this.getProduct();
  // this.osg.getFields('product', () => {
  //   if (this.tenantId != '1340835581184723420') {
  //     if (this.type == '3') {
  //       let arr = [];
  //       for (let obj of this.options.productType) {
  //         if (obj.value == '3') {
  //           arr.push(obj);
  //         }
  //       }
  //       this.options.productType = arr;
  //     } else {
  //       let arr = [];
  //       for (let obj of this.options.productType) {
  //         if (obj.value != '3') {
  //           arr.push(obj);
  //         }
  //       }
  //       this.options.productType = arr;
  //     }
  //     this.$forceUpdate();
  //   }
  //   this.osg.getFpi();
  //   this.getData();
  // });
  // }
  // }
};
</script>
